import React from "react";

const QuranQuickPlayButton = ({ isOpen, quickPlayPrompt, uiLabels, onQuickPlay }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <button
      type="button"
      className="quran-quick-play-btn"
      style={{ left: `${quickPlayPrompt.x}px`, top: `${quickPlayPrompt.y}px` }}
      onClick={(event) => {
        event.stopPropagation();
        onQuickPlay();
      }}
      title={uiLabels.launchRecitation}
      aria-label={uiLabels.launchRecitation}
    >
      <span className="quran-icon-glyph">▶</span>
    </button>
  );
};

export default QuranQuickPlayButton;